import { ContainerModule, interfaces } from 'inversify';
import { IRenameAttachmentBl, RenameAttachmentBl } from './RenameAttachment.bl';
import { IRenameAttachmentStore, RenameAttachmentStore } from './RenameAttachment.store';
import { CheckAttachmentNameUniquenessService, ICheckAttachmentNameUniquenessService } from './services/CheckAttachmentNameUniqueness.service';
import { IRenameAttachmentService, RenameAttachmentService } from './services/RenameAttachment.service';

export const renameAttachmentModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IRenameAttachmentStore.$).to(RenameAttachmentStore).inSingletonScope();
  bind(IRenameAttachmentService.$).to(RenameAttachmentService).inRequestScope();
  bind(ICheckAttachmentNameUniquenessService.$).to(CheckAttachmentNameUniquenessService).inRequestScope();
  bind(IRenameAttachmentBl.$).to(RenameAttachmentBl).inSingletonScope();
});
